// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"693":"css/app.6668","9084":"css/admin-app.6668"}[chunkId] + ".css";
};